// src/lib/role.ts
export type Role = 'initiator' | 'collaborator' | null;

type IssueLike = {
  initiatorEmail?: string | null;
  initiatorEmailLower?: string | null;
  collaboratorEmail?: string | null;
  collaboratorEmailLower?: string | null;
  id?: string | null;
};

/** Normalize to lower-case trimmed string */
function norm(e?: string | null) {
  return String(e ?? '').trim().toLowerCase();
}

/** Strict role detection with diagnostics. No defaulting. */
export function detectRoleStrict(
  userEmail?: string | null,
  issue?: IssueLike | null
): Role {
  const u = norm(userEmail ?? '');
  const iRaw = issue?.initiatorEmail ?? issue?.initiatorEmailLower ?? '';
  const cRaw = issue?.collaboratorEmail ?? issue?.collaboratorEmailLower ?? '';
  const i = norm(iRaw);
  const c = norm(cRaw);

  let role: Role = null;
  if (u && i && u === i) role = 'initiator';
  else if (u && c && u === c) role = 'collaborator';

  try {
    console.table({
      issueId: issue?.id ?? '',
      userEmail_input: userEmail ?? '',
      userEmail_norm: u,
      initiatorEmail_raw: String(iRaw),
      initiatorEmail_norm: i,
      collaboratorEmail_raw: String(cRaw),
      collaboratorEmail_norm: c,
      detectedRole: role ?? 'null',
    });
  } catch {}

  return role;
}

/** Back-compat alias */
export function detectRole(userEmail?: string | null, issue?: IssueLike | null): Role {
  return detectRoleStrict(userEmail, issue);
}
